const ACTIONS = {
  INIT_TIMER: 'init-timer',
  STOP_TIMER: 'stop-timer',
  SET_TIMER_OWNER: 'timer-owner'
}

export default ACTIONS
